// extracted by mini-css-extract-plugin
export default {"wrapper":"Burger_wrapper__5J4ww","burger":"Burger_burger__M2j09","active":"Burger_active__nRMn5","menu":"Burger_menu__da2B+","logo":"Burger_logo__w5iQW"};